// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"839":"b051d260","932":"0d0dd152"}[chunkId] + ".chunk.css";
};